import { useQuery } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";

export function useMadeEdit(assemblyGroupId?: string) {
  return useQuery({
    queryKey: ["madeEdit", assemblyGroupId],
    queryFn: async () => {
      if (!assemblyGroupId) return undefined;

      const data = await api.designLab.getMadeEdit({ asgid: assemblyGroupId });

      // Return null if empty object is returned (no project exists)
      if (!data || Object.keys(data).length === 0) {
        return undefined;
      }

      return objNamesToCamelCase(data);
    },
    enabled: !!assemblyGroupId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: Infinity
  });
}
